import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=8ed07906&"
import script from "./QuickReply.vue?vue&type=script&lang=js&"
export * from "./QuickReply.vue?vue&type=script&lang=js&"
import style0 from "./QuickReply.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports